// Translations for English, Hindi, and Punjabi
export const translations = {
  en: {
    // Login Page
    login: {
      title: "Sign In",
      subtitle: "Enter your credentials to access the system",
      email: "Email / Username",
      password: "Password",
      warehouse: "Select Warehouse",
      signIn: "Sign In",
      selectLanguage: "Select Language",
      forgotPassword: "Forgot Password?",
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      currentWarehouse: "Current Warehouse",
      totalProducts: "Total Products",
      totalStock: "Total Stock",
      lowStockAlerts: "Low Stock Alerts",
      outOfStock: "Out of Stock",
      lowStockItems: "Low Stock Items",
      threshold: "Threshold",
    },
    // Navigation/Tabs
    nav: {
      dashboard: "Dashboard",
      masterData: "Master Data",
      transactions: "Transactions",
      inventory: "Inventory",
      reports: "Reports",
      manufacturing: "Manufacturing",
      users: "Users",
      backup: "Backup",
      logout: "Logout",
    },
    // Master Data
    masterData: {
      products: "Products Master",
      vendors: "Vendors Master",
      categories: "Categories Master",
      warehouses: "Warehouses Master",
      addProduct: "Add Product",
      addVendor: "Add Vendor",
      addCategory: "Add Category",
      addWarehouse: "Add Warehouse",
      productName: "Product Name",
      category: "Category",
      vendorName: "Vendor Name",
      contact: "Contact",
      phone: "Phone",
      actions: "Actions",
    },
    // Transactions
    transactions: {
      title: "Stock Transactions",
      subtitle: "Record stock in and out movements",
      recordTransaction: "Record Transaction",
      type: "Type",
      quantity: "Quantity",
      date: "Date & Time",
      notes: "Notes",
      stockIn: "Stock In",
      stockOut: "Stock Out",
      driverName: "Driver's Name",
      driverContact: "Contact Number",
      vehicleNumber: "Vehicle Number",
      printChallan: "Print Challan",
    },
    // Inventory
    inventory: {
      title: "Current Warehouse Inventory",
      subtitle: "Latest available stock (Opening + In - Out)",
      openingStock: "Opening",
      inStock: "In Stock",
      outStock: "Out Stock",
      currentStock: "Current Stock",
      status: "Status",
      healthy: "Healthy",
      lowStock: "Low Stock",
      outOfStockStatus: "Out of Stock",
      setOpeningStock: "Set Opening Stock",
      printStock: "Print Stock",
      downloadExcel: "Download Excel",
    },
    // Manufacturing
    manufacturing: {
      title: "Manufacturing / Processing",
      subtitle: "Convert raw materials to finished goods",
      createBatch: "Create Batch",
      batchNumber: "Batch Number",
      inputMaterials: "Input Materials (Raw)",
      outputProduct: "Output Product (Finished)",
      outputQuantity: "Output Quantity",
      processLoss: "Process Loss / Shortage",
      processLossNotes: "Loss Notes",
      selectInputs: "Select Input Products",
      selectOutput: "Select Output Product",
      totalInputQty: "Total Input Qty",
      netOutput: "Net Output",
    },
    // Reports
    reports: {
      title: "Transaction Reports",
      filterBy: "Filter By",
      product: "Product",
      vendor: "Vendor",
      startDate: "Start Date",
      endDate: "End Date",
      sortBy: "Sort By",
      clearFilters: "Clear Filters",
    },
    // Admin
    admin: {
      userManagement: "User Management",
      warehouseManagement: "Warehouse Management",
      resetWarehouse: "Reset Transactions",
      resetConfirm: "Are you sure you want to reset all transactions for this warehouse? This action cannot be undone.",
      enterPassword: "Enter Admin Password",
      verify: "Verify & Reset",
      auditLogs: "User Activity Logs",
      localBackup: "Local Backup & Restore",
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      add: "Add",
      update: "Update",
      close: "Close",
      confirm: "Confirm",
      success: "Success",
      error: "Error",
      loading: "Loading...",
      noData: "No data available",
      required: "Required",
      kg: "kg",
    },
  },
  
  hi: {
    // Login Page
    login: {
      title: "साइन इन करें",
      forgotPassword: "पासवर्ड भूल गए?",
      subtitle: "सिस्टम तक पहुंचने के लिए अपनी साख दर्ज करें",
      email: "ईमेल / उपयोगकर्ता नाम",
      password: "पासवर्ड",
      warehouse: "गोदाम चुनें",
      signIn: "साइन इन करें",
      selectLanguage: "भाषा चुनें",
      forgotPassword: "पासवर्ड भूल गए?",
    },
    // Dashboard
    dashboard: {
      title: "डैशबोर्ड",
      currentWarehouse: "वर्तमान गोदाम",
      totalProducts: "कुल उत्पाद",
      totalStock: "कुल स्टॉक",
      lowStockAlerts: "कम स्टॉक अलर्ट",
      outOfStock: "स्टॉक खत्म",
      lowStockItems: "कम स्टॉक वाली वस्तुएं",
      threshold: "सीमा",
    },
    // Navigation/Tabs
    nav: {
      dashboard: "डैशबोर्ड",
      masterData: "मास्टर डेटा",
      transactions: "लेनदेन",
      inventory: "इन्वेंटरी",
      reports: "रिपोर्ट",
      manufacturing: "निर्माण",
      users: "उपयोगकर्ता",
      backup: "बैकअप",
      logout: "लॉग आउट",
    },
    // Master Data
    masterData: {
      products: "उत्पाद मास्टर",
      vendors: "विक्रेता मास्टर",
      categories: "श्रेणी मास्टर",
      warehouses: "गोदाम मास्टर",
      addProduct: "उत्पाद जोड़ें",
      addVendor: "विक्रेता जोड़ें",
      addCategory: "श्रेणी जोड़ें",
      addWarehouse: "गोदाम जोड़ें",
      productName: "उत्पाद का नाम",
      category: "श्रेणी",
      vendorName: "विक्रेता का नाम",
      contact: "संपर्क",
      phone: "फ़ोन",
      actions: "कार्रवाई",
    },
    // Transactions
    transactions: {
      title: "स्टॉक लेनदेन",
      subtitle: "स्टॉक की आवक और जावक दर्ज करें",
      recordTransaction: "लेनदेन दर्ज करें",
      type: "प्रकार",
      quantity: "मात्रा",
      date: "तारीख और समय",
      notes: "टिप्पणी",
      stockIn: "स्टॉक आवक",
      stockOut: "स्टॉक जावक",
      driverName: "चालक का नाम",
      driverContact: "संपर्क नंबर",
      vehicleNumber: "वाहन नंबर",
      printChallan: "चालान प्रिंट करें",
    },
    // Inventory
    inventory: {
      title: "वर्तमान गोदाम इन्वेंटरी",
      subtitle: "उपलब्ध स्टॉक (शुरुआती + आवक - जावक)",
      openingStock: "शुरुआती",
      inStock: "आवक स्टॉक",
      outStock: "जावक स्टॉक",
      currentStock: "वर्तमान स्टॉक",
      status: "स्थिति",
      healthy: "ठीक",
      lowStock: "कम स्टॉक",
      outOfStockStatus: "स्टॉक खत्म",
      setOpeningStock: "शुरुआती स्टॉक सेट करें",
      printStock: "स्टॉक प्रिंट करें",
      downloadExcel: "एक्सेल डाउनलोड करें",
    },
    // Manufacturing
    manufacturing: {
      title: "निर्माण / प्रसंस्करण",
      subtitle: "कच्चे माल को तैयार माल में बदलें",
      createBatch: "बैच बनाएं",
      batchNumber: "बैच नंबर",
      inputMaterials: "कच्चा माल (इनपुट)",
      outputProduct: "तैयार उत्पाद (आउटपुट)",
      outputQuantity: "आउटपुट मात्रा",
      processLoss: "प्रक्रिया हानि / कमी",
      processLossNotes: "हानि टिप्पणी",
      selectInputs: "इनपुट उत्पाद चुनें",
      selectOutput: "आउटपुट उत्पाद चुनें",
      totalInputQty: "कुल इनपुट मात्रा",
      netOutput: "शुद्ध आउटपुट",
    },
    // Reports
    reports: {
      title: "लेनदेन रिपोर्ट",
      filterBy: "फ़िल्टर करें",
      product: "उत्पाद",
      vendor: "विक्रेता",
      startDate: "शुरू तारीख",
      endDate: "अंतिम तारीख",
      sortBy: "क्रमबद्ध करें",
      clearFilters: "फ़िल्टर साफ़ करें",
    },
    // Admin
    admin: {
      userManagement: "उपयोगकर्ता प्रबंधन",
      warehouseManagement: "गोदाम प्रबंधन",
      resetWarehouse: "लेनदेन रीसेट करें",
      resetConfirm: "क्या आप वाकई इस गोदाम के सभी लेनदेन रीसेट करना चाहते हैं? यह कार्रवाई वापस नहीं की जा सकती।",
      enterPassword: "एडमिन पासवर्ड दर्ज करें",
      verify: "सत्यापित करें और रीसेट करें",
    },
    // Common
    common: {
      save: "सहेजें",
      cancel: "रद्द करें",
      delete: "हटाएं",
      edit: "संपादित करें",
      add: "जोड़ें",
      update: "अपडेट करें",
      close: "बंद करें",
      confirm: "पुष्टि करें",
      success: "सफलता",
      error: "त्रुटि",
      loading: "लोड हो रहा है...",
      noData: "कोई डेटा उपलब्ध नहीं",
      required: "आवश्यक",
      kg: "किग्रा",
    },
  },
  
  pa: {
    // Login Page
    login: {
      title: "ਸਾਈਨ ਇਨ ਕਰੋ",
      subtitle: "ਸਿਸਟਮ ਤੱਕ ਪਹੁੰਚਣ ਲਈ ਆਪਣੀ ਜਾਣਕਾਰੀ ਦਰਜ ਕਰੋ",
      email: "ਈਮੇਲ / ਯੂਜ਼ਰਨੇਮ",
      password: "ਪਾਸਵਰਡ",
      warehouse: "ਗੋਦਾਮ ਚੁਣੋ",
      signIn: "ਸਾਈਨ ਇਨ ਕਰੋ",
      selectLanguage: "ਭਾਸ਼ਾ ਚੁਣੋ",
      forgotPassword: "ਪਾਸਵਰਡ ਭੁੱਲ ਗਏ?",
    },
    // Dashboard
    dashboard: {
      title: "ਡੈਸ਼ਬੋਰਡ",
      currentWarehouse: "ਮੌਜੂਦਾ ਗੋਦਾਮ",
      totalProducts: "ਕੁੱਲ ਉਤਪਾਦ",
      totalStock: "ਕੁੱਲ ਸਟਾਕ",
      lowStockAlerts: "ਘੱਟ ਸਟਾਕ ਅਲਰਟ",
      outOfStock: "ਸਟਾਕ ਖਤਮ",
      lowStockItems: "ਘੱਟ ਸਟਾਕ ਵਾਲੀਆਂ ਚੀਜ਼ਾਂ",
      threshold: "ਸੀਮਾ",
    },
    // Navigation/Tabs
    nav: {
      dashboard: "ਡੈਸ਼ਬੋਰਡ",
      masterData: "ਮਾਸਟਰ ਡੇਟਾ",
      transactions: "ਲੈਣ-ਦੇਣ",
      inventory: "ਇਨਵੈਂਟਰੀ",
      reports: "ਰਿਪੋਰਟਾਂ",
      manufacturing: "ਨਿਰਮਾਣ",
      users: "ਯੂਜ਼ਰ",
      backup: "ਬੈਕਅੱਪ",
      logout: "ਲੌਗ ਆਊਟ",
    },
    // Master Data
    masterData: {
      products: "ਉਤਪਾਦ ਮਾਸਟਰ",
      vendors: "ਵਿਕਰੇਤਾ ਮਾਸਟਰ",
      categories: "ਸ਼੍ਰੇਣੀ ਮਾਸਟਰ",
      warehouses: "ਗੋਦਾਮ ਮਾਸਟਰ",
      addProduct: "ਉਤਪਾਦ ਜੋੜੋ",
      addVendor: "ਵਿਕਰੇਤਾ ਜੋੜੋ",
      addCategory: "ਸ਼੍ਰੇਣੀ ਜੋੜੋ",
      addWarehouse: "ਗੋਦਾਮ ਜੋੜੋ",
      productName: "ਉਤਪਾਦ ਦਾ ਨਾਮ",
      category: "ਸ਼੍ਰੇਣੀ",
      vendorName: "ਵਿਕਰੇਤਾ ਦਾ ਨਾਮ",
      contact: "ਸੰਪਰਕ",
      phone: "ਫ਼ੋਨ",
      actions: "ਕਾਰਵਾਈ",
    },
    // Transactions
    transactions: {
      title: "ਸਟਾਕ ਲੈਣ-ਦੇਣ",
      subtitle: "ਸਟਾਕ ਦੀ ਆਮਦ ਅਤੇ ਜਾਵਕ ਦਰਜ ਕਰੋ",
      recordTransaction: "ਲੈਣ-ਦੇਣ ਦਰਜ ਕਰੋ",
      type: "ਕਿਸਮ",
      quantity: "ਮਾਤਰਾ",
      date: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
      notes: "ਨੋਟਸ",
      stockIn: "ਸਟਾਕ ਆਮਦ",
      stockOut: "ਸਟਾਕ ਜਾਵਕ",
      driverName: "ਡਰਾਈਵਰ ਦਾ ਨਾਮ",
      driverContact: "ਸੰਪਰਕ ਨੰਬਰ",
      vehicleNumber: "ਵਾਹਨ ਨੰਬਰ",
      printChallan: "ਚਲਾਨ ਪ੍ਰਿੰਟ ਕਰੋ",
    },
    // Inventory
    inventory: {
      title: "ਮੌਜੂਦਾ ਗੋਦਾਮ ਇਨਵੈਂਟਰੀ",
      subtitle: "ਉਪਲਬਧ ਸਟਾਕ (ਸ਼ੁਰੂਆਤੀ + ਆਮਦ - ਜਾਵਕ)",
      openingStock: "ਸ਼ੁਰੂਆਤੀ",
      inStock: "ਆਮਦ ਸਟਾਕ",
      outStock: "ਜਾਵਕ ਸਟਾਕ",
      currentStock: "ਮੌਜੂਦਾ ਸਟਾਕ",
      status: "ਸਥਿਤੀ",
      healthy: "ਠੀਕ",
      lowStock: "ਘੱਟ ਸਟਾਕ",
      outOfStockStatus: "ਸਟਾਕ ਖਤਮ",
      setOpeningStock: "ਸ਼ੁਰੂਆਤੀ ਸਟਾਕ ਸੈੱਟ ਕਰੋ",
      printStock: "ਸਟਾਕ ਪ੍ਰਿੰਟ ਕਰੋ",
      downloadExcel: "ਐਕਸਲ ਡਾਊਨਲੋਡ ਕਰੋ",
    },
    // Manufacturing
    manufacturing: {
      title: "ਨਿਰਮਾਣ / ਪ੍ਰੋਸੈਸਿੰਗ",
      subtitle: "ਕੱਚੇ ਮਾਲ ਨੂੰ ਤਿਆਰ ਮਾਲ ਵਿੱਚ ਬਦਲੋ",
      createBatch: "ਬੈਚ ਬਣਾਓ",
      batchNumber: "ਬੈਚ ਨੰਬਰ",
      inputMaterials: "ਕੱਚਾ ਮਾਲ (ਇਨਪੁੱਟ)",
      outputProduct: "ਤਿਆਰ ਉਤਪਾਦ (ਆਊਟਪੁੱਟ)",
      outputQuantity: "ਆਊਟਪੁੱਟ ਮਾਤਰਾ",
      processLoss: "ਪ੍ਰੋਸੈਸ ਨੁਕਸਾਨ / ਘਾਟਾ",
      processLossNotes: "ਨੁਕਸਾਨ ਨੋਟਸ",
      selectInputs: "ਇਨਪੁੱਟ ਉਤਪਾਦ ਚੁਣੋ",
      selectOutput: "ਆਊਟਪੁੱਟ ਉਤਪਾਦ ਚੁਣੋ",
      totalInputQty: "ਕੁੱਲ ਇਨਪੁੱਟ ਮਾਤਰਾ",
      netOutput: "ਸ਼ੁੱਧ ਆਊਟਪੁੱਟ",
    },
    // Reports
    reports: {
      title: "ਲੈਣ-ਦੇਣ ਰਿਪੋਰਟਾਂ",
      filterBy: "ਫਿਲਟਰ ਕਰੋ",
      product: "ਉਤਪਾਦ",
      vendor: "ਵਿਕਰੇਤਾ",
      startDate: "ਸ਼ੁਰੂ ਤਾਰੀਖ",
      endDate: "ਅੰਤ ਤਾਰੀਖ",
      sortBy: "ਕ੍ਰਮਬੱਧ ਕਰੋ",
      clearFilters: "ਫਿਲਟਰ ਸਾਫ਼ ਕਰੋ",
    },
    // Admin
    admin: {
      userManagement: "ਯੂਜ਼ਰ ਪ੍ਰਬੰਧਨ",
      warehouseManagement: "ਗੋਦਾਮ ਪ੍ਰਬੰਧਨ",
      resetWarehouse: "ਲੈਣ-ਦੇਣ ਰੀਸੈੱਟ ਕਰੋ",
      resetConfirm: "ਕੀ ਤੁਸੀਂ ਸੱਚਮੁੱਚ ਇਸ ਗੋਦਾਮ ਦੇ ਸਾਰੇ ਲੈਣ-ਦੇਣ ਰੀਸੈੱਟ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ? ਇਹ ਕਾਰਵਾਈ ਵਾਪਸ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕਦੀ।",
      enterPassword: "ਐਡਮਿਨ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
      verify: "ਤਸਦੀਕ ਕਰੋ ਅਤੇ ਰੀਸੈੱਟ ਕਰੋ",
    },
    // Common
    common: {
      save: "ਸੇਵ ਕਰੋ",
      cancel: "ਰੱਦ ਕਰੋ",
      delete: "ਮਿਟਾਓ",
      edit: "ਸੋਧੋ",
      add: "ਜੋੜੋ",
      update: "ਅੱਪਡੇਟ ਕਰੋ",
      close: "ਬੰਦ ਕਰੋ",
      confirm: "ਪੁਸ਼ਟੀ ਕਰੋ",
      success: "ਸਫਲਤਾ",
      error: "ਗਲਤੀ",
      loading: "ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ...",
      noData: "ਕੋਈ ਡੇਟਾ ਉਪਲਬਧ ਨਹੀਂ",
      required: "ਲੋੜੀਂਦਾ",
      kg: "ਕਿਲੋ",
    },
  },
};

export const getTranslation = (lang, path) => {
  const keys = path.split('.');
  let result = translations[lang] || translations.en;
  for (const key of keys) {
    result = result?.[key];
    if (!result) {
      // Fallback to English
      result = translations.en;
      for (const k of keys) {
        result = result?.[k];
      }
      break;
    }
  }
  return result || path;
};

export default translations;
